<template>
  <div class="home">
    <el-container>
      <!-- 头部导航 -->
      <Header />
      <div class="main-content">
        <!-- 主体内容 -->
        <el-main>
          <router-view></router-view>
        </el-main>
      </div>
      <a href="#" class="fixed-button">Boka nu</a>
      <el-footer class="footer" style="height: 100%;">
        <Footer />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
export default {
  name: "HomePage",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      phoneImgUrl: require("@/assets/header/header-phone.png"),
      logoImgUrl: require("@/assets/header/logo.png"),
      isSmallScreen: window.innerWidth < 768,
      isMenuVisible: false,
    };
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      this.isSmallScreen = this.screenWidth < 768;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
};
</script>

<style scoped lang="scss">
.home {
  height: 100vh;
  width: 100%;
  /* 新增一个容器用于包裹主体内容，设置最大宽度和居中对齐 */
  .main-content {
    min-width: 1200px; /* 与头部最大宽度保持一致 */
    margin: 0 auto; /* 水平居中 */
    /* 主体内容 */
    .el-main {
      flex: 1; /* 让 el-main 占满剩余空间 */
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f8f8f8;
      overflow: hidden; /* 禁止滚动 */
      padding: 0;
    }
  }
  /* 固定按钮样式 */
  .fixed-button {
    position: fixed;
    right: 5px; /* 离右侧 20px */
    top: 50%; /* 垂直居中 */
    transform: translateY(-50%);
    background-color: #e91e63; /* 粉色背景 */
    color: white;
    padding: 12px 18px;
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
    border-radius: 5px;
    writing-mode: vertical-rl; /* 文字竖排 */
    text-align: center;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .el-footer {
    padding: 20px 0;
  }

  /* 鼠标悬停效果 */
  .fixed-button:hover {
    background-color: #c2185b;
  }

  /* 屏幕缩小时，按钮缩小 */
  // @media (max-width: 768px) {
  //   .fixed-button {
  //     padding: 8px 12px;
  //     font-size: 12px;
  //     right: 10px; /* 离右侧更近 */
  //   }
  // }
}
</style>